import { createFileRoute, redirect } from '@tanstack/react-router';
import { paths } from '@/routes/paths';

// The content-blocks management page has been replaced by the email-document section
// library at /dashboard/sections. Preserve old bookmarks with a redirect.
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/content-blocks')({
  beforeLoad: () => {
    throw redirect({ to: paths.dashboard.sections });
  },
});
